exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  /* color */\n\n  /* font */\n\n  /* link */\n}\n:root {\n  /* цвет */\n\n  /* TODO в фигме другие цвета по названиям scarlet magenta green beeline aquamarine violet, надо решить с дизайнерами  */\n\n  /* токены со ссылкой на глобал цвета */\n\n  /* шрифт */\n\n  /* отступы от шапки и футера до тела страницы */\n\n  /* ширина тела страницы */\n\n  /* отступы между элементами страницы */\n}\n.FamilyMembersList_description_1owj {\n  margin-bottom: 16px;\n}\n@media (min-width: 768px) {\n  .FamilyMembersList_description_1owj {\n    margin-bottom: 24px;\n  }\n}\n.FamilyMembersList_list-items_2TWq {\n  margin: 0;\n  padding: 0;\n\n  display: grid;\n  grid-row-gap: 24px;\n}\n", ""]);

// exports
exports.locals = {
	"description": "FamilyMembersList_description_1owj",
	"list-items": "FamilyMembersList_list-items_2TWq"
};